export const onlyNumber = (number: string | number) => {
  if (typeof number === 'number') {
    return number;
  }
  return Number(number?.replace(/[^\d]+/g, ''));
};
